const ADJECTIVES = [
  'brave', 'gentle', 'fierce', 'wise', 'calm', 'bold', 'quiet', 'steady',
  'lunar', 'amber', 'rose', 'silver', 'violet', 'sage', 'ember', 'saffron',
  'radiant', 'tender', 'warm', 'bright', 'soft', 'deep', 'kind', 'strong',
]

const NOUNS = [
  'warrior', 'phoenix', 'willow', 'cedar', 'river', 'harbor', 'horizon',
  'compass', 'lotus', 'pioneer', 'wanderer', 'voyager', 'keeper', 'dreamer',
  'seeker', 'weaver', 'spark', 'bloom', 'aurora', 'oracle', 'thread', 'tide',
]

export function generateHandle(): string {
  const adj = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)]
  const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)]
  const num = Math.floor(Math.random() * 90) + 10
  return `${adj}-${noun}-${num}`
}
